var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        attrs: {
          "error-messages": _vm.validationMessage,
          items: _vm.groups,
          label: _vm.label,
          rules: _vm.rules,
          "item-text": "name",
          "item-value": "id"
        },
        model: {
          value: _vm.contextModel,
          callback: function($$v) {
            _vm.contextModel = $$v
          },
          expression: "contextModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }